import { createContext } from 'react';
export const SelectionStoreContext = /*#__PURE__*/createContext(undefined);